import { css } from '@emotion/css';
import { colors } from '@editor2/styles/colors';

export const scoreSettingsContainer = css`
	color: ${colors.mainText};

	.form-check {
		margin-bottom: 10px;
	}

	.subBlock {
		margin-left: 20px;

		.form-check-label {
			font-size: 14px;
		}
	}

	.numberInputWrapper {
		display: flex;
		align-items: end;
		margin-bottom: 10px;

		input {
			width: 60px;
			padding: 3px;
			height: 100%;
			margin-right: 20px;
		}
	}
`;

export const scoreSettingsPreview = css`
	border: 1px solid ${colors.border};
	border-radius: 4px;
	color: ${colors.infoText};
	padding: 10px;
	margin-bottom: 20px;

	ul {
		margin-bottom: 0;
	}

	button {
		margin-top: 20px;
	}

	.noSettingText {
		color: ${colors.placeholder};
		font-style: italic;
	}
`;
